import { useQuery, useMutation } from '@tanstack/react-query';
import { addSelectedGeofence, getSelectedGeofences } from 'src/backend/team';
import useAuth from './useAuth';

export const useAddSelectedGeofence = (options) => {
  return useMutation({ mutationFn: addSelectedGeofence, ...options });
};

export const useGetSelectedGeofences = (options) => {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['teamGeofences'],
    queryFn: getSelectedGeofences,
    ...options,
    enabled: !!(user?.is_executive ?? false),
  });
};
